import { genericPage, getMappingProgramaSlug, isCr, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /nom-bonic-programa/seccio/nom-seccio/id/

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS, 'programa', 'seccio']);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);

    let path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'seccio'];

    if (isCr(mapping)) {
        path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'seccio-radio'];
    }
    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
